
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/circleci/wineaccess/nuxt-app/sentry.client.config.ts")
            }
          });